export default "__VITE_ASSET__921ba0d2__"